export const isAuthenticated = (state) => state.auth.authenticated;
export const verificationIsFetching = (state) => state.auth.isVerificationFetch;
export const verificationCodeSent = (state) => state.auth.verificationSent;
export const verificationCodeSendError = (state) => state.auth.verificationSendError;
export const verificationCodeSendErrorMessage = (state) => state.auth.verificationSendErrorMessage;
export const showIntro = (state) => state.auth.showIntro;


export const validationIsFetching = (state) => state.auth.isValidationFetch;
export const validationError = (state) => state.auth.validationError;
export const validationErrorMessage = (state) => state.auth.validationErrorMessage;

export const getUserId = (state) => state.auth.userId;
export const getUserProfile = (state) => state.auth.user;
export const getTokenId = (state) => state.auth.id_token;
export const getAccessToken = (state) => state.auth.access_token;
export const getPhoneNumber = (state) => state.auth.phone_number;
export const getFirebaseToken = (state) => state.auth.firebase.id_token;
export const getLocation = (state) => state.auth.location;
export const haveMobileApp = (state) => state.auth.haveMobileApp;
